import React from 'react';

const TalkWithUsIcon = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3915 13.8045L12.6931 16.5029L5.49735 9.3071L8.19577 6.60868L3.69841 2.11133L1 4.80974C1 13.7514 8.24884 21.0002 17.1905 21.0002L19.8889 18.3018L15.3915 13.8045Z"
      stroke="#FF5900"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.2222 1C17.5181 1 21 4.48185 21 8.77778"
      stroke="#FF5900"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1111 4.3335C15.1789 4.3335 17.6667 6.82127 17.6667 9.88905"
      stroke="#FF5900"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TalkWithUsIcon;
